/**
 * Horizontal Scroll - Pin section and scroll project cards horizontally
 * Integrated with Lenis for smooth momentum/inertia
 *
 * Behavior:
 * 1. User scrolls, heading text scrolls up naturally
 * 2. When __pin reaches top of viewport, it pins (position: fixed)
 * 3. Vertical scroll converts to horizontal movement on card rows
 * 4. Top row moves left, bottom row moves right (stagger)
 * 5. Lenis provides smooth deceleration
 * 6. When fully scrolled, section unpins and page continues vertical scroll
 */
import lenis from "./smoothScroll.js";

(function () {
  var section = document.getElementById('home-work');
  if (!section) return;

  var pin = section.querySelector('.home-work__pin');
  var rowTop = section.querySelector('.home-work__row--top');
  var rowBottom = section.querySelector('.home-work__row--bottom');
  var heading = section.querySelector('.home-work__heading');

  if (!pin || !rowTop || !rowBottom) return;

  function getHeadingHeight() {
    return heading ? heading.offsetHeight : 0;
  }

  function getMaxScroll() {
    var topWidth = rowTop.scrollWidth - pin.clientWidth;
    var bottomInit = window.innerWidth >= 992 ? 60 : (window.innerWidth >= 576 ? 40 : 20);
    var bottomWidth = rowBottom.scrollWidth + bottomInit - pin.clientWidth;
    return Math.max(topWidth, bottomWidth, 0);
  }

  function setSectionHeight() {
    var maxScroll = getMaxScroll();
    var pinHeight = pin.offsetHeight;
    section.style.height = (getHeadingHeight() + pinHeight + maxScroll) + 'px';
  }

  function applyTransforms(scrollVal) {
    var maxScroll = getMaxScroll();
    var clamped = Math.max(0, Math.min(scrollVal, maxScroll));

    var bottomInit = window.innerWidth >= 992 ? -60 : (window.innerWidth >= 576 ? -40 : -20);
    rowTop.style.transform = 'translateX(' + (-clamped) + 'px)';
    rowBottom.style.transform = 'translateX(' + (bottomInit - clamped) + 'px)';
  }

  function update() {
    var sectionRect = section.getBoundingClientRect();
    var maxScroll = getMaxScroll();
    var headingH = getHeadingHeight();
    var scrolled = -sectionRect.top - headingH;

    if (scrolled >= 0 && scrolled <= maxScroll) {
      pin.style.position = 'fixed';
      pin.style.top = '0';
      pin.style.left = '0';
      pin.style.right = '0';
      pin.style.bottom = 'auto';
    } else if (scrolled > maxScroll) {
      pin.style.position = 'absolute';
      pin.style.top = 'auto';
      pin.style.bottom = '0';
      pin.style.left = '0';
      pin.style.right = '0';
    } else {
      pin.style.position = 'relative';
      pin.style.top = '';
      pin.style.left = '';
      pin.style.right = '';
      pin.style.bottom = '';
    }

    applyTransforms(scrolled);
  }

  setSectionHeight();
  update();
  applyTransforms(0);

  lenis.on('scroll', update);

  window.addEventListener('resize', function () {
    setSectionHeight();
    update();
  });
})();
